import React from 'react';
import {
  IconButton,
  Tooltip,
  useTheme as useMuiTheme,
  useMediaQuery,
} from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
} from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

const ThemeSwitcher: React.FC = () => {
  const { themeMode, toggleTheme } = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  return (
    <Tooltip title={`Switch to ${themeMode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton
        onClick={toggleTheme}
        sx={{
          color: muiTheme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.9)' 
            : 'rgba(0, 0, 0, 0.8)',
          backgroundColor: 'transparent',
          borderRadius: 2,
          p: 1.5,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            backgroundColor: muiTheme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.1)' 
              : 'rgba(0, 0, 0, 0.05)',
            transform: 'scale(1.05)',
            color: muiTheme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 1)' 
              : 'rgba(0, 0, 0, 1)',
          },
          '&:active': {
            transform: 'scale(0.95)',
          },
        }}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={themeMode}
            initial={{ rotate: -90, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            exit={{ rotate: 90, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            {themeMode === 'light' ? (
              <DarkModeIcon 
                sx={{ 
                  fontSize: isMobile ? 20 : 24,
                  color: 'inherit',
                }} 
              />
            ) : (
              <LightModeIcon 
                sx={{ 
                  fontSize: isMobile ? 20 : 24,
                  color: 'inherit',
                }} 
              />
            )}
          </motion.div>
        </AnimatePresence>
      </IconButton>
    </Tooltip>
  );
};

export default ThemeSwitcher; 